import React, { lazy } from 'react'
import { Redirect, Route } from 'react-router-dom';

const Package = lazy(() => import('../features/Package'));
const Session = lazy(() => import('../features/Session'));
const SessionShow = lazy(() => import('../features/Session/show'));
const Profile = lazy(() => import('../features/Auth/profile'));
const Video = lazy(() => import('../features/Video'));

const AuthRoute = ({ isLogin, from }) => (
    <>
        {isLogin ?
            <>
                <Route exact path='/profile' component={Profile} />
                <Route exact path='/courses/:packageId/sessions' component={Session} />
                <Route exact path='/courses/:packageId/sessions/:sessionId' component={SessionShow} />
                <Route exact path='/courses' component={Package} />
                <Route exact path='/video/:videoLink/:poster' component={Video} />
                {/* <Redirect to="/packages" /> */}
            </>
            :
            <>
                <Redirect to={{ pathname: "/get-code", state: { from } }} />
            </>
        }
    </>
)

export default AuthRoute